import React from "react";
import {Drawer, Form, Button, Col, Row, Input, Select, DatePicker,TimePicker} from 'antd';
import { LoadDataAnyEndpoint} from "../../../api/fn";
import moment from "moment";
import {GetUserToken} from "../../../api/token";
import {yesNoOption} from "../../../constants";


const {Option} = Select;
const { TextArea } = Input;

const makeCol = (row, _this) => {
    let { handleChangeInput} = _this;
    const onChangeDate=(date,dateString,fieldName)=>{
        handleChangeInput(dateString,fieldName)
    }
    const onChangeStartTime=(time, timeString,key)=> {
        handleChangeInput(timeString,key)
        console.log("onChangeStartTime > ",time, timeString);
    }
    if (row === null) {
        return null;
    }
    if(row.datatype==="date"){
        return(
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.label}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <DatePicker
                        style={{maxWidth:'100%',minWidth:"100%"}}
                        onChange={(date,dateString)=>onChangeDate(date,dateString,row.fieldname)}
                    />
                </Form.Item>
            </Col>
        )
    }
    if(row.datatype==="time"){
        return(
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.label}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <TimePicker
                        style={{maxWidth:'100%',minWidth:"100%"}}
                        onChange={(time,timeString)=>onChangeStartTime(time,timeString,row.fieldname)}
                        defaultOpenValue={moment('00:00:00', 'HH:mm:ss')}
                    />

                </Form.Item>
            </Col>
        )
    }



    if (row.datatype === "textarea") {
        return(
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.label}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <TextArea
                        onChange={(e) => handleChangeInput(e.target.value, row.fieldname)}
                    />
                </Form.Item>
            </Col>
        )
    }
    if (row.datatype === "list") {
        let options = [];
        for (let i in row.options) {
            let recOption=row.options[i];
            const key = recOption.key;
            const val = recOption.val;
            options.push({
                key: key,
                val: val,
            })
        }
        return (
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.label}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <Select
                        placeholder={"Please enter user " + row.fieldname}
                        onChange={(e) => handleChangeInput(e, row.fieldname)}
                    >
                        {options.map(rec => {
                            return (
                                <Option value={rec.key}>{rec.val}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            </Col>
        )
    }
    return (
        <Col span={12}>
            <Form.Item
                name={row.fieldname}
                label={row.label}
                rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
            >
                <Input
                    placeholder={"Please enter user " + row.fieldname}
                    onChange={(e) => handleChangeInput(e.target.value, row.fieldname)}
                />
            </Form.Item>
        </Col>
    )
}

export default class NewPriorityDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            selectedPriority:"",
            newEntry:{},
        }
    }

    handleChange = async (e, key) => {
        const value = e.value;
        this.setState({
            [key]: value,
        });

    }
    handleChangeInput=(val,key)=>{
        let tmp=this.state;
        tmp.newEntry[key]=val;
        this.setState(tmp);
    }

    onSubmit=async ()=>{
        let {_this } = this.props;
        let {state, handleChangeInput, handleChangeInput2} = _this;
        let data = state.ActionData;
        if(data===null){return }
        let org = data.record.org;
        let project = data.record.module;

        if(project===""){
            return alert("sorry please select")
        }
        let self=this;

        if (!window.confirm("Are you sure to submit this record!")) {
            return
        }

        let workDate = moment().format("YYYY-MM-DD");
        let userInfo = GetUserToken();
        let username  = userInfo.Username;


        let hub = {
            ...this.state.newEntry,
            Org: org,
            module: project,
            Ref: data.record.ref,
            Agent:username,
            Name: this.getTitle()
        }
        hub.expiryvalue = parseFloat(hub.expiryvalue);


        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = {}
        let endpoint = "/common/entity/Reminders/insert"; // "/manager/entity/insert/extensions";

        console.log("onSubmit new reminder send 2 > ", post);

        await LoadDataAnyEndpoint(post, endpoint, "Data", this,async (dataOut) => {
            console.log("onSubmit new reminder response > ", dataOut);
            self.onClose();
            _this.setState({
                newEntry:{},
            });
            //await SubmitLogInformation(org,project,"status","all",self.state.selectedStatus,data.record.ref,o,self)
            alert("Thank you record added!")

        });

    }

    getAttributes=()=>{
        let ls=[
            {fieldname: "title", datatype: "string", required: true, label: "Title", options: [],show:true},
            {fieldname: "scheduledate", datatype: "date", required: true, label: "Date", options: [],show:true},
            {fieldname: "scheduletime", datatype: "time", required: true, label: "Time", options: [],show:true},
            {fieldname: "expirytype", datatype: "list", required: true, label: "Expiry Type", options: [
                    {key: "hour", val: "Hour"},
                    {key: "day", val: "Day"},
                ],show:true},
            {fieldname: "expiryvalue", datatype: "float", required: true, label: "Expiry Value", options: [],show:true},
            {fieldname: "comment", datatype: "textarea", required: true, label: "Comment", options: [],show:true},
        ];

        return ls

    }
    getTitle=()=>{
        let {_this } = this.props;
        let {state} = _this;
        if(state.ActionData!==null){
            return state.ActionData.name;
        }
        return "----"
    }
    onClose=()=>{
        let {_this } = this.props;
        _this.setState({
            showActionReminder:false,
            ActionData:null
        })
    }


    render() {
        let {_this } = this.props;
        let {state} = _this;
        let attributes = this.getAttributes()

        let ls = [];
        let loopIndex = 0;
        for (let i = 0; i < attributes.length; i += 2) {
            loopIndex = i;
            const row = attributes[i];
            let row2 = null;
            let nextIndex = i + 1;
            if (nextIndex < (attributes.length)) {
                row2 = attributes[nextIndex]
            }
            ls.push(
                <Row gutter={16}>
                    {makeCol(row, this)}
                    {makeCol(row2, this)}
                </Row>
            );
        }

        return (
            <>
                <Drawer
                    title={"Create a new Reminder for :"+this.getTitle()}
                    width={720}
                    onClose={this.onClose}
                    visible={state.showActionReminder}
                    bodyStyle={{paddingBottom: 80}}
                    footer={
                        <div
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <Button onClick={this.onClose} style={{marginRight: 8}}>
                                Cancel
                            </Button>
                            <Button onClick={this.onSubmit} type="primary">
                                Submit
                            </Button>
                        </div>
                    }
                >

                    <Form layout="vertical" hideRequiredMark>
                        {ls.map(row => {
                            return row;
                        })}

                    </Form>
                </Drawer>
            </>
        )
    }
}
